import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { showConfirmAlert } from "../../components/components-react/ReactAlert";
import Loader from "../../components/ui/Loader";
import { commonPostPutApi } from "../../redux/reducers/commonApiSlice";
import { resolve_gym_feedback_issue } from "../../data/ApiEndpoints";
import { convertStraight } from "../../components/common-data/Converts";

const GymIssueResolveForm = ({ userInfoData, rowData, callFunction }) => {
  const dispatch = useDispatch();
  const { postPutLoading1 } = useSelector((state) => state.common);

  const forminitials = {
    isActive: false,
  };
  const [formValues, setFormValues] = useState(forminitials);

  const onChangeInput = (e) => {
    const { name, value, type, checked } = e.target;

    setFormValues((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmitForm = async (payload) => {
    const method = "PUT";
    const endpoint = resolve_gym_feedback_issue;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        setFormValues(forminitials);
        callFunction();
        toast.success(result?.payload?.message || "Success!");
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  const onSubmit = () => {
    const userData = {
      uid: rowData?.uid || "",
      resolve_status: formValues.isActive ? 1 : 0,
    };

    const handleConfirm = async () => {
      handleSubmitForm(userData);
    };

    showConfirmAlert(
      handleConfirm,
      "Verify before proceeding",
      "No, Cancel",
      "Yes, Submit Form"
    );
  };

  return (
    <>
      <div className="user-profile-container staff-onboarding-detail-modal">
        <div className="user-profile-details">
          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">user info</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">
                {rowData?.name || "NA"}
                <br />
                <small
                  style={{
                    textTransform: "lowercase",
                    textDecoration: "underline",
                  }}>
                  {rowData?.mobile || ""}
                </small>
              </p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">role</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">
                {rowData?.account_type?.replace(/_/g, " ") || ""}
              </p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">gym name</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">{rowData?.gym_name || "NA"}</p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">rating</p>
            </div>
            <div className="user-details-info">
              <p className="info-name"> {rowData?.rating || "-"} ✰</p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">feedback</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">{rowData?.feedback || "NA"}</p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">feedback for</p>
            </div>
            <div className="user-details-info">
              <p className="info-name icon">
                {rowData?.category?.replace(/_/g, " ") || ""}
              </p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">Feedback Date</p>
            </div>
            <div className="user-details-info">
              <p className="info-name icon">
                {rowData?.date_added
                  ? convertStraight(rowData.date_added)
                  : "-"}
              </p>
            </div>
          </div>
        </div>
      </div>

      <form className="formContainer mb15">
        <div className="formInputsGrid switchInputs">
          <div className={`commonWrapper commonSwitchWrapper no-border span3`}>
            <Form.Check
              type="switch"
              name="isActive"
              label={`Mark As Resolved`}
              className={`hygine-label ${formValues.isActive ? "active" : ""}`}
              checked={formValues.isActive}
              onChange={onChangeInput}
            />
          </div>
        </div>

        <div className="formButtons" style={{ justifyContent: "flex-end" }}>
          {postPutLoading1 ? (
            <Loader />
          ) : (
            <Button
              type="button"
              className="saveBtn"
              variant="primary"
              onClick={onSubmit}
              disabled={!formValues.isActive}>
              approve
            </Button>
          )}
        </div>
      </form>
    </>
  );
};

export default GymIssueResolveForm;
